
import Button from '~/components/elements/Button';
import BannerSideWrapper from '~/components/elements/BannerSideWrapper';
import BlogCardHeader from '~/components/blog/Card/Header';

export default {
  name: 'BlogCardMain',
  components: {BlogCardHeader, BannerSideWrapper, Button},
  props: {
    article: {
      type: Object,
      required: true,
    },
    banner: {
      type: Object,
      required: true,
    },
    ratio: {
      type: Object,
      default() {
        return {}
      },
    },
    sizes: {
      type: Object,
      default() {
        return {}
      },
    },
    place: {
      type: String,
      default: 'right',
    },
    align: {
      type: String,
      default: 'top',
    },
    round: {
      type: Boolean,
      default: true,
    },
    borderRadius: {
      type: String,
      default: '.4rem',
    },
  },
}
